import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'hooks/redux'
import strings from 'utils/strings'

import { getSelectedId } from 'selectors/navigator'
import { setSelectedIdWithDrawer } from 'actions/navigator'
import { useMakeDispatchCallback } from 'hooks'

import { HISTORY } from 'constants/featureSnapshots'

import { Icon, Button } from 'components/patterns'
import Card from 'components/Card'
import { FeatureHistoryCardContent } from 'components/feature/FeatureHistory'

import {
  HistoryItemHeader,
  HistoryItemContent,
} from './FeatureHistoryTopNav.style'

const FeatureHistoryTopNav = ({
  snapshotUri,
  children,
  selectedSnapshot,
  location,
}) => {
  const setSelectedIdCallback = useMakeDispatchCallback(setSelectedIdWithDrawer)

  const selectedId = useSelector(getSelectedId)

  const isHistoryRoute = !!snapshotUri
  const showHistoryListNav = selectedId === HISTORY

  const handleFullHistorySelect = () => {
    setSelectedIdCallback(HISTORY)
  }

  const { uri, date, user } = selectedSnapshot
  const selected = uri === snapshotUri

  return (
    <>
      {isHistoryRoute && !showHistoryListNav && (
        <>
          <HistoryItemHeader>
            <Icon icon="history" size="small" />
            <Button link onClick={() => handleFullHistorySelect()}>
              {strings.full_history}
            </Button>
          </HistoryItemHeader>

          <HistoryItemContent>
            <Card
              key={uri}
              content={
                <FeatureHistoryCardContent
                  uri={uri}
                  selected={selected}
                  user={user}
                  date={date}
                  location={location}
                />
              }
              selected={selected}
              onClickDisabled={true}
            />
          </HistoryItemContent>
        </>
      )}
      {children}
    </>
  )
}

FeatureHistoryTopNav.propTypes = {
  snapshotUri: PropTypes.string,
  selectedSnapshot: PropTypes.object,
  children: PropTypes.node,
  location: PropTypes.object,
}

export default FeatureHistoryTopNav
